import { motion } from "framer-motion";
import { Quote, Trash2, TrendingUp } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
export const imageUrl = (id) => `${API}/api/media/${id}/image`;

const fmt = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
};

export const MediaCard = ({ item, copy, canDelete, onOpen, onDelete, index }) => {
  const Icon = item.kind === "testimonial" ? Quote : TrendingUp;
  return (
    <motion.figure
      initial={{ opacity: 0.4, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.7, delay: (index % 4) * 0.05, ease: [0.22, 1, 0.36, 1] }}
      className="group relative mb-3 break-inside-avoid overflow-hidden rounded-[22px] border border-white/[0.07] bg-surface/70 sm:mb-4"
      data-testid={`results-item-${item.id}`}
    >
      <button type="button" onClick={() => onOpen(item)} className="block w-full overflow-hidden" data-testid={`results-open-${item.id}`}>
        <img
          src={imageUrl(item.id)}
          alt={item.caption || copy.tabs[item.kind]}
          width={item.width}
          height={item.height}
          loading="lazy"
          className="h-auto w-full transition-transform duration-700 group-hover:scale-[1.03]"
        />
      </button>
      <figcaption className="p-3 sm:p-4">
        <div className="flex items-center justify-between gap-2">
          <span className="flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.15em] text-gold">
            <Icon className="h-3.5 w-3.5" /> {copy.tabs[item.kind]}
          </span>
          <span className="font-mono text-[11px] text-zinc-400">{fmt(item.created_at)}</span>
        </div>
        {item.caption && <p className="mt-2 text-sm leading-snug text-zinc-200">{item.caption}</p>}
        {item.author && <p className="mt-1 text-[12px] text-zinc-400">— {item.author}</p>}
      </figcaption>
      {canDelete && (
        <button type="button" onClick={() => onDelete(item)} aria-label="delete" data-testid={`results-delete-${item.id}`}
          className="absolute right-2 top-2 flex h-9 w-9 items-center justify-center rounded-full bg-black/70 text-zinc-200 backdrop-blur transition-colors hover:bg-red-500 hover:text-white">
          <Trash2 className="h-4 w-4" />
        </button>
      )}
    </motion.figure>
  );
};
